// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const routeComponents: Record<string, () => Promise<any>> = {
  inbox: () =>
    import('../../components/pages/inbox/inbox.component').then(
      (m) => m.InboxComponent,
    ),
  chat: () =>
    import('../../components/pages/chat/chat.component').then(
      (m) => m.ChatComponent,
    ),
  registrationData: () =>
    import('../../components/pages/my-data/my-data.component').then(
      (m) => m.PersonalDataPage,
    ),
  scoreCard: () =>
    import('../../components/pages/score-card/score-card.component').then(
      (m) => m.ScoreCardComponent,
    ),
  cme: () =>
    import('../../components/pages/cme/cme.component').then(
      (m) => m.CmeComponent,
    ),
  barcodeEticettes: () =>
    import('../../components/pages/barcode-eticetts/barcode-eticetts.component').then(
      (m) => m.BarcodeEticetts,
    ),
  ehba: () =>
    import('../../components/pages/ehba/ehba.component').then(
      (m) => m.EhbaComponent,
    ),
  hba: () =>
    import('../../components/pages/hba/hba.component').then(
      (m) => m.HbaComponent,
    ),
  digitalExemptionProcess: () =>
    import('../../components/pages/digital-exemption-process/digital-exemption-process.component').then(
      (m) => m.DigitalExemptionProcessComponent,
    ),
  educationEvaluation: () =>
    import('../../components/pages/education-evaluation/education-evaluation.component').then(
      (m) => m.EducationEvaluationComponent,
    ),
  contribution: () =>
    import('../../components/pages/contribution/contribution.component').then(
      (m) => m.ContributionComponent,
    ),
  examResults: () =>
    import('../../components/pages/exam-results/exam-results.component').then(
      (m) => m.ExamResultsPageComponent,
    ),
  mfaDiary: () =>
    import('../../components/pages/mfa-diary/mfa-diary.component').then(
      (m) => m.MfaDiary,
    ),
  mfaDiaryDetail: () =>
    import('../../components/shared/mfa-diary-detail/mfa-diary-detail.component').then(
      (m) => m.MfaDiaryDetail,
    ),
  styleguide: () =>
    import('../../components/dev/styleguide/styleguide.component').then(
      (m) => m.StyleguideComponent,
    ),
  shortcuts: () =>
    import('../../components/pages/shortcuts/shortcuts.component').then(
      (m) => m.LandingShortcutsComponent,
    ),

  emergencySign: () =>
    import('../../components/pages/emergency-sign/emergency-sign.component').then(
      (m) => m.EmergencySignComponent,
    ),

  midExamRegistration: () =>
    import('../../components/pages/exam-registration/mid-exam-registration/mid-exam-registration.component').then(
      (m) => m.MidExamRegistration,
    ),

  finalExamRegistration: () =>
    import('../../components/pages/exam-registration/final-exam-registration/final-exam-registration.component').then(
      (m) => m.FinalExamRegistration,
    ),

  educationApplications: () =>
    import('../../components/pages/education-applications/education-applications.component').then(
      (m) => m.EducationApplicationsComponent,
    ),
};
